import React from "react";
import type { HeroData } from "./types";
import liriworksImage from "../../assets/Liriworks.webp";

interface HeroSectionProps {
  readonly hero: Readonly<HeroData>;
}

export default function HeroSection({ hero }: HeroSectionProps) {
  const [titleFirstPart, ...titleRestParts] = hero.title.split(" with ");
  const titleRest = titleRestParts.join(" with ");

  return (
    <section className="bg-gradient-to-br from-blue-50 via-blue-100 to-indigo-100 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-6">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-10 items-start">

          {/* Left: Text */}
          <div>
            <h1 className="text-[1.84rem] lg:text-[3.59rem] font-bold leading-[1.08] text-[#0e1a35] mb-6">
              {titleRest ? (
                <>
                  {titleFirstPart}
                  <br />
                  <span className="whitespace-nowrap">with {titleRest}</span>
                </>
              ) : (
                hero.title
              )}
            </h1>
            <p className="text-xl text-[#334b73] leading-relaxed mb-8 max-w-2xl">
              {hero.description}
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href={hero.primaryCta.href}
                className="px-6 py-3 bg-[#2563eb] text-white text-sm font-semibold rounded-lg hover:bg-[#1f52c9] transition-colors shadow-md"
              >
                {hero.primaryCta.label}
              </a>
              <a
                href={hero.secondaryCta.href}
                className="px-6 py-3 bg-[#f4f8ff] text-[#2563eb] text-sm font-semibold border-2 border-[#2563eb] rounded-lg hover:bg-[#e9f0ff] transition-colors"
              >
                {hero.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="hidden md:flex lg:justify-end">
            <div className="relative w-full md:w-[620px] lg:w-[760px] xl:w-[820px] h-[280px] lg:h-[360px] xl:h-[380px] rounded-2xl overflow-hidden shadow-2xl bg-white/50 backdrop-blur-sm border border-white/20">
              <img
                src={liriworksImage}
                alt="Liriworks dashboard preview"
                decoding="async"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  color: "transparent",
                  objectFit: "fill",      // changed from contain -> fill (stretches to cover)
                  objectPosition: "center",
                  padding: "0px",         // removed inner gap
                }}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}